import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "form-items cf" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = {
  class: "label",
  for: "Email"
}
const _hoisted_7 = { class: "item" }
const _hoisted_8 = {
  class: "control",
  "data-type": "password"
}
const _hoisted_9 = {
  class: "label",
  for: "Password"
}
const _hoisted_10 = {
  key: 0,
  class: "icon fastic-eye-show"
}
const _hoisted_11 = {
  key: 1,
  class: "icon fastic-eye-hide"
}
const _hoisted_12 = {
  key: 0,
  class: "item"
}
const _hoisted_13 = {
  class: "control",
  "data-type": "password"
}
const _hoisted_14 = {
  class: "label",
  for: "ConfirmPassword"
}
const _hoisted_15 = {
  key: 0,
  class: "icon fastic-eye-show"
}
const _hoisted_16 = {
  key: 1,
  class: "icon fastic-eye-hide"
}
const _hoisted_17 = { class: "fieldset" }
const _hoisted_18 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_19 = {
  class: "form-items",
  "data-type": "buttons"
}
const _hoisted_20 = { class: "item calltoaction" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "lable" }

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountPasswordReset',
  props: {
    code: {}
  },
  setup(__props: any) {

const props = __props;

const formHelper = FormHelper;
const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);
const isHidden = ref(true);
const isHiddenCheck = ref(true);
const options = ref<any>(null);

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
});

async function submitForm() {
    validationErrors.value = [];

    isLoading.value = true;
    formData.value.code = props.code;

    try {
        let response = await Axios.post(routes.Account_PasswordReset, formData.value);

        isSuccess.value = true;

        GTagHelper.sendEvent("form_submit", "account_login");

        window.location.href = response.data.redirectUrl ? response.data.redirectUrl : "/";
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoading.value = false;
}

function showPasswordIcon() {
    isHidden.value = !isHidden.value;
}

function showPasswordIconCheck() {
    isHiddenCheck.value = !isHiddenCheck.value;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", {
      class: "fieldset mrg",
      "data-mrgt": "20",
      disabled: isLoading.value
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(localizer).get("App.Account.Email")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "Email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
              autocomplete: "email",
              class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'textbox'])
            }, null, 2), [
              [
                _vModelText,
                formData.value.email,
                void 0,
                { lazy: true }
              ]
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(localizer).get("App.Account.Password")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "Password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.Password) = $event)),
              autocomplete: "off",
              class: _normalizeClass([{ 'input-validation-error': isValidationError('Password') }, 'textbox'])
            }, null, 2), [
              [
                _vModelText,
                formData.value.Password,
                void 0,
                { lazy: true }
              ]
            ]),
            _createElementVNode("button", {
              class: "show-password",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(formHelper).showPassword('Password'), showPasswordIcon()))
            }, [
              (isHidden.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                : (_openBlock(), _createElementBlock("span", _hoisted_11))
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
          ])
        ]),
        (options.value?.isPasswordCheck)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(localizer).get("Account.Common.PasswordCheck")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  id: "ConfirmPassword",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.passwordCheck) = $event)),
                  autocomplete: "off",
                  class: _normalizeClass([{ 'input-validation-error': isValidationError('ConfirmPassword') }, 'textbox'])
                }, null, 2), [
                  [
                    _vModelText,
                    formData.value.passwordCheck,
                    void 0,
                    { lazy: true }
                  ]
                ]),
                _createElementVNode("button", {
                  class: "show-password",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(formHelper).showPassword('ConfirmPassword'), showPasswordIconCheck()))
                }, [
                  (isHiddenCheck.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16))
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_2),
    _createElementVNode("fieldset", _hoisted_17, [
      (validationErrors.value.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            id: "ButtonSubmit",
            class: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (submitForm())),
            disabled: isLoading.value
          }, [
            _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
          ], 8, _hoisted_21)
        ])
      ])
    ])
  ]))
}
}

})